export default "__VITE_ASSET__6b3d3b3a__"